import { render, staticRenderFns } from "./my_trade.vue?vue&type=template&id=ff3ef504&scoped=true&"
import script from "./my_trade.vue?vue&type=script&lang=js&"
export * from "./my_trade.vue?vue&type=script&lang=js&"
import style0 from "./my_trade.vue?vue&type=style&index=0&id=ff3ef504&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3ef504",
  null
  
)

export default component.exports